"use client";
import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();

  const styles = {
    wrapper: {
      position: "fixed",
      left: 0,
      right: 0,
      bottom: 0,
      width: "100%",
      backgroundColor: "#5a6274",
      color: "#fff",
      zIndex: 1000,
      boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
    },
    inner: {
      maxWidth: 1200,
      margin: "0 auto",
      padding: "10px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "0.9rem",
    },
    link: {
      color: "#fff",
      textDecoration: "none",
      opacity: 0.95,
      whiteSpace: "nowrap",
    },
    center: { opacity: 0.95, whiteSpace: "nowrap" },
  };

  return (
    <footer style={styles.wrapper}>
      <div style={styles.inner}>
        <a
          style={styles.link}
          href="https://docs.wixstatic.com/ugd/6c2537_bd4a46fa96ce4cf5b0df97e744174bd9.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        <div style={styles.center}>Copyright © {year} Shinnyo-en UK</div>
        <a
          style={styles.link}
          href="https://shinnyo-offerings.uk/refund-policy.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Refund Policy
        </a>
      </div>
    </footer>
  );
};

export default Footer;